<main class="layout-profile-sidebar">
  <header class="breadcrumb">
    <button (click)="back()" class="button tertiary d-none d-sm-flex" type="button">
      <span class="icon icon-arrow-left"></span>
      <ng-container i18n="@@profile.edit.btnBack">Zurück</ng-container>
    </button>
  </header>
  <article class="layout-ignore">
    <header class="header">
      <h1 class="heading" i18n="@@profile.edit.title">Profil bearbeiten</h1>
    </header>
    <aside class="sidebar">
      <nav>
        <h2 class="sr-only" i18n="sr-only@@profile.edit.pageNavigation">Seitennavigation</h2>
        <ul class="navbar-nav vertical sticky">
          <li [class.link-active]="(activeFragment | async) === null || (activeFragment | async) === 'personal-data'"
            class="nav-item">
            <a [replaceUrl]="true" [routerLink]='"."' class="nav-link" fragment="personal-data"
            i18n="@@profile.edit.link.personalDetails">Personalien</a>
          </li>
          <li [class.link-active]="(activeFragment | async) === 'assistance'" class="nav-item">
            <a [replaceUrl]="true" [routerLink]='"."' class="nav-link" fragment="assistance"
            i18n="@@profile.edit.link.assistance">Assistenz</a>
          </li>
          <li [class.link-active]="(activeFragment | async) === 'visibility'" class="nav-item">
            <a [replaceUrl]="true" [routerLink]='"."' class="nav-link" fragment="visibility"
            i18n="@@profile.edit.link.visibility">Sichtbarkeit</a>
          </li>
          <li [class.link-active]="(activeFragment | async) === 'actions'" class="nav-item">
            <a [replaceUrl]="true" [routerLink]='"."' class="nav-link" fragment="actions"
            i18n="@@profile.edit.link.actions">Aktionen</a>
          </li>
        </ul>
      </nav>

    </aside>
    <div class="content">
      <h2 class="sr-only" i18n="sr-only@@profile.edit.titleContents">Inhalt</h2>

      @if (form) {
        <form [formGroup]="form">
          <section class="section" id="personal-data">
            <h3 class="heading">
              <button (click)="toggle('personal-data')" [class.up]="showPersonalData"
                aria-controls="personalData"
                aria-expanded="showPersonalData" class="caret button semantic-only d-sm-none"
                i18n="@@profile.edit.title.personalDetails" type="button">Personalien
                        </button>
              <span class="d-none d-sm-block" i18n="@@profile.edit.title.personalDetails">Personalien</span>
            </h3>
            <div [class.d-none]="!showPersonalData" class="d-sm-block" id="personalData">
              @if (isGiver) {
                <app-giver-profile #giverProfile [parentGroup]="step1"></app-giver-profile>
                <app-giver-profile-details [form]="form" [memberId]="member.id"
                [parentGroup]="step2"></app-giver-profile-details>
              }
              @if (isRecipient) {
                <app-recipient-profile #recipientProfile [parentGroup]="step1"></app-recipient-profile>
                <app-recipient-profile-details [form]="form" [memberId]="member.id"
                [parentGroup]="step2"></app-recipient-profile-details>
              }
            </div>
          </section>
          <section class="section" id="assistance">
            <h3 class="heading">
              <button (click)="toggle('assistance')" [class.up]="showAssistance" aria-controls="assistance"
                aria-expanded="showAssistance" class="caret button semantic-only d-sm-none"
                i18n="@@profile.edit.title.assistance" type="button">Assistenz
                        </button>
              <span class="d-none d-sm-block" i18n="@@profile.edit.title.assistance">Assistenz</span>
            </h3>
            <div [class.d-none]="!showAssistance" class="d-sm-block" id="assistance">
              @if (isGiver) {
                <app-giver-offer [parentGroup]="step3"></app-giver-offer>
              }
              @if (isRecipient) {
                <app-recipient-offer [parentGroup]="step3"></app-recipient-offer>
              }
            </div>
          </section>
          <section class="section" id="visibility">
            <h3 class="heading" id="input-offer-active">
              <button (click)="toggle('visibility')" [class.up]="showVisibility" aria-controls="visibility"
                aria-expanded="showVisibility" class="caret button semantic-only d-sm-none"
                i18n="@@profile.edit.title.visibility" type="button">Sichtbarkeit
                            meines Profils
                        </button>
              <span class="d-none d-sm-block" i18n="@@profile.edit.title.visibility">Sichtbarkeit meines Profils</span>
            </h3>
            <div [class.d-none]="!showVisibility" class="form-group form-row d-sm-block" id="visibility">
              <app-segment-button-list
                (valueChange)="activeOfferControl.setValue($event); activeOfferControl.markAsDirty();"
                [selectableTags]="activeOfferControlChoices"
                [value]="activeOfferControl.value"
                labelledby="input-offer-active">
              </app-segment-button-list>
            </div>
          </section>
          <div class="save-button section">
            <button (click)="submit()" [disabled]="!form.dirty || !form.valid" class="button primary block-xs"
              i18n="@@profile.edit.btn.submit" type="button">Speichern
                    </button>
          </div>
        </form>
      }
      <section id="actions">
        <h3 class="heading" i18n="@@profile.edit.title.actions">Aktionen</h3>
        <div class="actions form-group">
          <button (click)="changeEmail()" class="button block-xs" i18n="@@profile.edit.btn.changeEmail"
            type="button">E-Mail ändern
                    </button>
          <button (click)="changePassword()" class="button block-xs" i18n="@@profile.edit.btn.changePassword"
            type="button">Passwort ändern
                    </button>
          <button (click)="deleteMember()" class="button block-xs" i18n="@@profile.edit.btn.deleteMember"
            type="button">Konto löschen
                    </button>
        </div>
      </section>
    </div>
  </article>
</main>
